import { useEffect, useState, useRef } from 'react';
import { DISPLAY_LANG } from '../../../config';
import { useNavigate } from 'react-router-dom';
import Loading from '../../../components/loading';
import api from '../../../axios';
import '../../../stylesheets/sslApprovedEmail.css';

export default function SSLApprovedEmail() {
  const [domainName, setDomainName] = useState('');
  const [productCode, setProductCode] = useState('');
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(() => localStorage.getItem('ssl_approved_domain_email') || '');
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    const ssl_approved_domain_name = localStorage.getItem('ssl_approved_domain_name') || '';
    const ssl_product_code = localStorage.getItem('ssl_product_code') || '';
    setDomainName(ssl_approved_domain_name);
    setProductCode(ssl_product_code);

    if (!ssl_approved_domain_name || !ssl_product_code) return;

    setLoading(true);
    setError(null);

    window.scrollTo(0, 0);

    api.post('ssl/approver-list', { domain_name: ssl_approved_domain_name, product_code: ssl_product_code })
      .then(res => {
        const list = res.data.ApproverEmailList || [];
        setEmails(list);
      })
      .catch(err => setError(err?.message || 'Request failed'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    function onDoc(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('click', onDoc);
    return () => document.removeEventListener('click', onDoc);
  }, []);

  function handleSelect(email) {
    setSelected(email);
    localStorage.setItem('ssl_approved_domain_email', email);
    setOpen(false);
  }

  function instructionText() {
    const am = `Ընտրելով այս e-mail-ը՝ խնդրում ենք ստեղծել այն ձեր cPanel կամ ISPmanager-ի մեջ՝ ${domainName}, որպեսզի կարողանաք ստանալ հավաստագրումը եւ շարունակել procese-ը.`;
    const en = `By choosing this e-mail please create it in your cPanel or ISPmanager for ${domainName}, so you can receive the approval and continue the process.`;
    const ru = `Выбрав этот e-mail, создайте его в вашем cPanel или ISPmanager для ${domainName}, чтобы получить подтверждение и продолжить процесс.`;
    const map = { am, en, ru };
    return map[DISPLAY_LANG] || en;
  }

  if (loading) return <Loading />;

  return (
    <div className="ssl-approved-root">
      <h2 className="ssl-title">SSL Approver Email</h2>
      
      <div className="panel">
        <div className="field">
          <label>Domain</label>
          <div className="value">{domainName || '-'}</div>
        </div>
        <div className="field">
          <label>Product Code</label>
          <div className="value">{productCode || '-'}</div>
        </div>

        <div className="field">
          <label>{DISPLAY_LANG === 'am' ? 'Ընտրեք e-mail' : DISPLAY_LANG === 'ru' ? 'Выберите e-mail' : 'Select e-mail'}</label>
          <div className="custom-select" ref={dropdownRef}>
            <button className="select-toggle" onClick={() => setOpen(o => !o)}>
              <span className="selected-text">{selected || (emails.length ? '— select —' : (loading ? 'Loading...' : 'No emails'))}</span>
              <span className="caret">▾</span>
            </button>
            {open && (
              <ul className="options">
                {emails.length === 0 && !loading && <li className="option empty">{DISPLAY_LANG === 'am' ? 'Ոչինչ գտնված չէ' : DISPLAY_LANG === 'ru' ? 'Ничего не найдено' : 'No results'}</li>}
                {emails.map((e, i) => (
                  <li key={i} className="option" onClick={() => handleSelect(e)}>
                    {e}
                    {e === 'none' ? <span className="note"> ({DISPLAY_LANG === 'am' ? 'չի առաջարկվում' : DISPLAY_LANG === 'ru' ? 'не предлагается' : 'not recommended'})</span> : null}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <p className="instruction">{instructionText()}</p>

        <div className="actions">
          <button className="continue-btn" onClick={() => navigate('/user/ssl/agreement')} disabled={!selected}>
            Continue
          </button>
        </div>

        {error && <div className="error">{error}</div>}
      </div>
    </div>
  );
}
